import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const BookingStep1 = r => require.ensure([], () => r(require('../components/BookingStep1'))) // eslint-disable-line global-require
const BookingStep2 = r => require.ensure([], () => r(require('../components/BookingStep2'))) // eslint-disable-line global-require
const BookingStep3 = r => require.ensure([], () => r(require('../components/BookingStep3'))) // eslint-disable-line global-require
const BookingStep4 = r => require.ensure([], () => r(require('../components/BookingStep4'))) // eslint-disable-line global-require
const BookingStep5 = r => require.ensure([], () => r(require('../components/BookingStep5'))) // eslint-disable-line global-require
const BookingWaitlist = r => require.ensure([], () => r(require('../components/BookingWaitlist'))) // eslint-disable-line global-require
const BookingFormular = r => require.ensure([], () => r(require('../components/BookingFormular'))) // eslint-disable-line global-require

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/step1',
      name: 1,
      component: BookingStep1
    }, {
      path: '/step2',
      name: 2,
      component: BookingStep2
    }, {
      path: '/step3',
      name: 3,
      component: BookingStep3
    }, {
      path: '/step4',
      name: 4,
      component: BookingStep4
    }, {
      path: '/step5',
      name: 5,
      component: BookingStep5
    }, {
      path: '/waitlist',
      name: 'waitlist',
      component: BookingWaitlist
    },
    {
      path: '/formular',
      name: 'formular',
      component: BookingFormular
    }
  ]
})
